var productList = {

    isScrolling:false,

    currentTabIndex:0,

    navSwiper: null,

    openedCategory: [], //记录打开的分类字段

    navIds : window.productListType == 'computer' ? ['product-description','success-case','product-solution','meeting-activity','product-source'] : ['hot-search','product-description','success-case','product-solution','meeting-activity','product-source'],

    jumpTo: function(index){
        var jumpid = this.navIds[index];

        this.changeNavigationBarStatus(index);

        this.isScrolling = true;

        var self = this;

        if (index == 0){
            $('html, body').animate({scrollTop: 0}, 1000,'',function () {
                // self.isScrolling = false;
            });
            return false;
        }
        $('html, body').animate({scrollTop: document.getElementById(jumpid).offsetTop - 100}, 1000, '', function () {
            // self.isScrolling = false;
        })

    },

    // 修改tab导航状态
    changeNavigationBarStatus: function(index){
        if (this.currentTabIndex == index) {
            return;
        }
        $('.product-category').find('li').removeClass('selected');
        $('.product-category').find('li').eq(index).addClass('selected');

        this.currentTabIndex = index;

        // navigation 滑动效果
        if ( window.productListType != 'computer'){
            if (index > this.navIds.length / 2 - 1) {
                this.navSwiper.setTransition(200);
                this.navSwiper.setTranslate(-50);
            } else {
                this.navSwiper.setTransition(200);
                this.navSwiper.setTranslate(0);
            }
        }
    },

    navioffsetTop: 0,

    scrollEvent: function(){
        var self = this;

        $('body').on('touchmove', function () {
            self.isScrolling = false;
        })

        this.navioffsetTop = $('.swiper-container-index').offset().top + $('.swiper-container-index').height() - 40;
        $(window).scroll(function () {
            var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

            if (scrollTop >  self.navioffsetTop && !$('.product-category').hasClass('product-category-fixed')){
                $('.product-category').addClass('product-category-fixed');
                $('.hot-search').attr('style','margin-top: .8rem')
            } else if(scrollTop <=  self.navioffsetTop && $('.product-category').hasClass('product-category-fixed')){
                $('.product-category').removeClass('product-category-fixed');
                $('.hot-search').attr('style','margin-top: 0')
            }

            if (!self.isScrolling) {
                self.offsetTopNavs = [];
                for (var i = 0; i < self.navIds.length; i++) {
                    var id =  "#" + self.navIds[i];
                    if (document.querySelector(id)){
                        self.offsetTopNavs.push(document.querySelector(id).offsetTop);
                    }
                }


                scrollTop = scrollTop + 100;
                for (var i = 0; i < self.offsetTopNavs.length; i++) {
                    //加一个tab高度，否则挡住标题才能会触发tab切换

                    if (i < self.offsetTopNavs.length - 1 && scrollTop >= self.offsetTopNavs[i] && scrollTop < self.offsetTopNavs[i+1] && self.currentTabIndex != i){
                        self.changeNavigationBarStatus(i);
                        break;
                    }else if (scrollTop >= self.offsetTopNavs[self.offsetTopNavs.length - 1] && self.currentTabIndex != self.offsetTopNavs.length - 1) {
                        self.changeNavigationBarStatus(self.offsetTopNavs.length - 1);
                        break;
                    }
                }

            }

        });
    },

    controlProductShow: function(i){
        if ($("#category-product-" + i + ' .category-product').hasClass('hide')) {
            $("#category-product-" + i + ' .category-product').removeClass('hide');
            debugger
            $('#handle-button-' + i).addClass('handle-button-open');
            this.openedCategory.push(i);
        }else {
            $("#category-product-" + i + ' .category-product').addClass('hide');
            $('#handle-button-' + i).removeClass('handle-button-open');
            var index = this.openedCategory.indexOf(i);
            this.openedCategory.splice(index,1);
        }
        console.log(this.openedCategory);
    },

    initNavSwiper: function(){
        this.navSwiper = new Swiper('.swiper-container-navigation' ,{
            slidesPerView: 'auto',
            freeMode: true,
        })

        setTimeout(function () {
            new Swiper('.swiper-container-product-recommend',{
                slidesPerView: 'auto',
                spaceBetween: 0,
                freeMode: true
            })
        },1000)
    },

    //产品采购单
    openBargainDialog: function(id, name, desc, imgurl) {
        var _this = this;
        // userRecode({behaviorType: '采购意向单', behaviorResult: productName, entrance: productName + '/' + productId});
        stopEvent();
        var productInfo = {
            productName: name,
            productImgUrl: imgurl,
            productDesc:desc,
            productNum: '1',
            productSale: $("#product-sale")?$("#product-sale").text():'',
            productPrice: $("#product-price")?$("#product-price").text():'',
            productId: id,
            productType: $('.product-type').find('.product-type-item-sel').length > 0 ? $('.product-type').find('.product-type-item-sel').eq(0).text(): ''
        }
        var formConfig = window.cateData.purchaseIntentionForm;
        formConfig.entrance = name + '/' + id;
        gio('track', 'buysubmitclick_product', {'ibuyEntrancePageTitle': document.title, 'ibuyEntrancePageURL': document.URL})  //埋点实施方案
        msg.batchDialog(productInfo, formConfig);

    },

    initHotSearchSwiper: function(){
        //
        var  hot = new Swiper('#swiper-container-hotsearch',{
            slidesPerView : 2,
            slidesPerGroup: 2,
            spaceBetween: 20,
            pagination: {
                el: '#swiper-pagination-hotsearch'
            }
        })
        console.log(hot)
    },

    // 点击详情弹窗（如果有型号）
    showDetail: function(obj){

        if ($("#" + $(obj).attr('data-objectid'))) {

            var childrens = $("#"+$(obj).attr('data-objectid')).find('div');

            var types = [];
            for (var i = 0; i < childrens.length; i++) {
                types.push({
                    title: $(childrens[i]).find('input')[0].value,
                    link: $(childrens[i]).find('input')[1].value
                })
            }

            if (types.length > 0) {

                var productInfo = {
                    productName: $(obj).attr('data-title'),
                    productImgUrl:$(obj).attr('data-img'),
                    productDesc:$(obj).attr('data-desc'),
                    productTypes: types,
                    typeClickFun: productList.setOpendCategoryToSession
                };

                msg.dialogPorductSelect(productInfo)
            } else {
                window.location.href = $(obj).attr('data-link');
                this.setOpendCategoryToSession();
            }

        }else {
            window.location.href = $(obj).attr('data-link');
            this.setOpendCategoryToSession();
        }


    },

    openServerView: function(){
        var self = this;
        stopEvent();
        kefuServer.shouqianSever();
        var timer = null;
        function addServerCloseEvent() {
            if (document.getElementById('ntalker')) {
                clearInterval(timer);
                timer = null;
                $("#ntalker").on("click", function(event){
                    self.changeNavigationBarStatus(0);
                });
            } else{
                timer = setInterval(function () {
                    addServerCloseEvent();
                },1000);
            }
        }
        addServerCloseEvent();
    },

    //产品采购单
    openBargainDialog: function() {
        var _this = this;
        // userRecode({behaviorType: '采购意向单', behaviorResult: productName, entrance: productName + '/' + productId});
        gio('track', 'buysubmitclick_product', {'ibuyEntrancePageTitle': document.title, 'ibuyEntrancePageURL': document.URL})  //埋点实施方案
        msg.ProjectConsultingDialog();
    },

    setOpendCategoryToSession: function(){
        sessionStorage.setItem('product-opned-category',JSON.stringify(productList.openedCategory))
    },

    emptyOpendCategory: function(){
        sessionStorage.removeItem('product-opned-category');
    },

    getOpendCategory: function(){
        var opend =  sessionStorage.getItem('product-opned-category');
        return opend ? JSON.parse(opend) : null;
    },

    scrollTo: function(ele){
        console.log(ele)
        if(!ele){
            return;
        }
        setTimeout(function () {
            $('html, body').animate({scrollTop: $('#pos'+ele).offset().top - 100 + 'px'}, 500);
        },1000)
    },



    // 显示更多资料
    isMaterialListShowMore : false,
    MaterialListShowMoreOffset : 0,
    materialShowMore: function () {
        var el = document.querySelector('.product-source-content');
        var iconEl = document.querySelector('.product-source').querySelector('.more-btn');
        if(!this.isMaterialListShowMore){
            this.isMaterialListShowMore = !this.isMaterialListShowMore;
            el.classList.add('product-source-content-show-more');
            iconEl.classList.add('shouqi');
            this.MaterialListShowMoreOffset = document.documentElement.scrollTop;
        }else{
            this.isMaterialListShowMore = !this.isMaterialListShowMore;
            el.classList.remove('product-source-content-show-more');
            iconEl.classList.remove('shouqi');
            document.documentElement.scrollTop = this.MaterialListShowMoreOffset;
        }
    },

    init: function () {
        this.initNavSwiper();
        this.scrollEvent();
        var self = this;
        setTimeout(function () {
            self.initHotSearchSwiper();
        });

        // this.scrollTo(getUrlPara('pos'));

        // gettatInfo();

        if (parseInt($("#bannercount").val()) <= 1){
            mySwiper.autoplay.stop();
        }

        var opendCategory = this.getOpendCategory();
        console.log('opendCategory',opendCategory)
        //根据category参数定位到指定二级分类产品位置
        var categoryLen = $("#product-list").find('.category-title').length;
        for (var i = 0; i < categoryLen; i++) {

            var categoryText = $("#product-list").find('.category-title').eq(i).attr('data-tabname');

            console.log(categoryText);

            if ((opendCategory && opendCategory.indexOf(categoryText) > -1) || (getUrlPara('category') && getUrlPara('category').replace(/\s*/g,"") == categoryText) || categoryLen == 1) {
                console.log('open', i);
                $("#product-list").find('.handle-button').eq(i).addClass('handle-button-open');

                var proid = "#category-product-" + categoryText;

                $(proid).find('.category-product').removeClass('hide');

                this.openedCategory.push(categoryText);
                // setTimeout(function () {
                //     $('html, body').animate({scrollTop: $("#product-list").find('.category-title').eq(i).offset().top - 100 }, 300);
                // },500);
                // break;
            }
        }

        this.emptyOpendCategory();

        // 设置直播入口
        // setLiveIcon();

    }
}
